<div class="backArrow" *ngIf="currentStep === 'form'">
  <img src="./assets/img/Back.svg" alt="" class="backArrowImage" (click)="back()" [ngClass]="{'backArrowImageMobile': isMobile}">
</div>
<ng-container *ngIf="!isMobile; else mobileView">
  <div class="stepperContainer">
    <div class="stepContainer pointer" (click)="toStep('contact-info')">
      <div class="stepCountTitle">
        {{'FORM.STEP_TEXT' | translate}} 01
      </div>
      <div class="stepTitle">
        {{'FORM.CONTACT_FORM.TITLE' | translate}}
      </div>
      <div class="stpeLine stpeLineActive"></div>
    </div>
    <div class="stepContainer pointer">
      <div class="stepCountTitle">
        {{'FORM.STEP_TEXT' | translate}} 02
      </div>

      <div class="stepTitle">
        {{'FORM.REQUEST_FORM.TITLE' | translate}}
      </div>
      <div class="stpeLine stpeLineActive" [ngClass]="{'stpeLineActive' : currentStep === 'form'}"></div>
    </div>
  </div>
</ng-container>

<div class="stepRemark" [ngSwitch]="currentStep" [ngClass]="{'stepRemarkMobileMargin' : isMobile}">
  <div *ngSwitchCase="'contact-info'">
    {{ 'FORM.CONTACT_FORM.REMARK' | translate }}
  </div>
  <div *ngSwitchCase="'form'">
    {{ 'FORM.REQUEST_FORM.REMARK' | translate}}
  </div>
</div>

<div class="mainTitle" [ngSwitch]="currentStep" [ngClass]="{'mobileMainTitle': isMobile}">
  <div *ngSwitchCase="'contact-info'">
    {{ 'FORM.CONTACT_FORM.SUB_TITLE' | translate | translateCut: 0 }}
    <span class="prettyLetters">{{ 'FORM.CONTACT_FORM.SUB_TITLE' | translate | translateCut: 1 }}</span>
  </div>
  <div *ngSwitchCase="'form'">
    {{ 'FORM.REQUEST_FORM.SUB_TITLE' | translate | translateCut: 0 }}
    <span class="prettyLetters">{{ 'FORM.REQUEST_FORM.SUB_TITLE' | translate | translateCut: 1 }}</span>
  </div>
</div>



<ng-template #mobileView>
  <div class="stepsCountContainer">
    {{'FORM.STEP_TEXT' | translate}} {{currentStep === 'contact-info' ? '1' : '2'}} {{'FORM.OF_TEXT' | translate}} 2
  </div>
  <div class="mobileStepContainer" [ngSwitch]="currentStep" >
    <div class="stepTitle" *ngSwitchCase="'contact-info'">
      {{'FORM.CONTACT_FORM.TITLE' | translate}}
    </div>
    <div class="stepTitle" *ngSwitchCase="'form'">
      {{'FORM.REQUEST_FORM.TITLE' | translate}}
    </div>
    <div class="mobileStepLineContainer">
      <div class="mobileStepLine stpeLineActive"> </div>
      <div class="mobileStepLine" [ngClass]="{'stpeLineActive' : currentStep === 'form' }"></div>
    </div>
  </div>
</ng-template >